import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { CombinedProviders } from 'components/CombinedProviders/CombinedProviders';
import { AlertProvider } from 'components/Alert';
import AppRoutes from 'components/AppRoutes/AppRoutes';
import ErrorBoundary from 'components/ErrorBoundary';
import { history } from 'functions';
import customMuiTheme from 'utils/constants/customMuiTheme';
import { initI18n } from 'utils/actions/intl';
import AppTranslationWrapper from 'components/AppTranslationWrapper';
import { PageHeaderProvider } from 'components/PageHeader/PageHeaderContext';
import { MatchesFilterProvider } from 'modules/matchesFilter/MatchesFilterContext';

initI18n();

const providers = [
  { provider: ErrorBoundary },
  { provider: MuiThemeProvider, props: { theme: customMuiTheme } },
  { provider: ConnectedRouter, props: { history } },
  { provider: AppTranslationWrapper },
  { provider: AlertProvider },
  { provider: PageHeaderProvider },
  { provider: MatchesFilterProvider },
];

export const App = () => (
  <CombinedProviders providers={providers}>
    <AppRoutes />
  </CombinedProviders>
);
